import { useLocation } from 'react-router';

export default function useQueryParam(paramName: string): string | null {
  const params = new URLSearchParams(useLocation().search);
  return params.get(paramName);
}
